import axios from "axios";

const RETRY_DELAYS_MS = [4000, 8000];

// The upstream RelayRigs app intermittently sleeps/cold-starts, surfacing as a 503
// or a network error. Auto-retries a couple of times with a short delay before
// giving up, so a sleepy upstream doesn't show a scary error on the first try.
export const postWithRetry = async (url, payload, onRetrying) => {
  let lastErr;
  for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt++) {
    try {
      return await axios.post(url, payload);
    } catch (err) {
      lastErr = err;
      const status = err.response?.status;
      const isSleepyUpstream = status === 503 || !err.response;
      if (isSleepyUpstream && attempt < RETRY_DELAYS_MS.length) {
        onRetrying?.(attempt + 1);
        await new Promise((resolve) => setTimeout(resolve, RETRY_DELAYS_MS[attempt]));
        continue;
      }
      throw lastErr;
    }
  }
  throw lastErr;
};
